<template>
  <div>
    <div class="flex flex-col max-w-xl mx-auto my-10">
      <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
        <div class="flex flex-col">
          <div
            class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 "
          >
            <div class="flex">
              <div
                class="bg-gray-200 rounded-sm shadow-xs p-4 m-4 inline-flex mx-auto"
              >
                When a subscriber abandoned the cart
              </div>
            </div>
            <div v-if="isLoading">
              <Spinner />
            </div>
            <ul role="list" class="space-y-3">
              <li
                class="overflow-hidden rounded-md bg-white px-6 py-4 shadow"
                v-for="(notificationConfig,
                index) of abandonedCartNotificationConfig.configs"
                :key="index"
              >
                <h3 class="text-base font-semibold leading-6 text-gray-900">
                  Reminder {{ index + 1 }}
                </h3>
                <div class="mt-2 max-w-xl text-sm text-gray-500">
                  <fieldset>
                    <legend
                      class="text-base leading-6 font-medium text-gray-900"
                    >
                      Enable
                    </legend>
                    <div class="mt-4 flex flex-wrap">
                      <VSwitch
                        v-model="notificationConfig.isEnabled"
                        @input="updateNotificationConfig"
                      />
                    </div>
                  </fieldset>
                  <div>
                    <label
                      for="location"
                      class="block text-sm font-medium leading-6 text-gray-900"
                      >Timing</label
                    >
                    <select
                      class="mt-2 block w-full rounded-md py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6 border p-3"
                      v-model="notificationConfig.timeout"
                      @input="updateNotificationConfig"
                    >
                      <option
                        v-for="(option, index) of abandonedCartTiming"
                        :key="index"
                        :value="option.value"
                        >{{ option.label }}</option
                      >
                    </select>
                    <p class="mt-3 text-sm leading-6 text-gray-600">
                      Wait for

                      {{
                        getLabelForValue(
                          notificationConfig.timeout,
                          abandonedCartTiming
                        )
                      }}
                      after cart is abandoned, then send
                    </p>
                  </div>
                  <p></p>
                </div>
                <div class="mt-5">
                  <button
                    class="Polaris-Button"
                    type="button"
                    @click="gotoConfigEditor(index)"
                  >
                    <span class="Polaris-Button__Content">
                      <span class="Polaris-Button__Text">Edit Automation</span>
                    </span>
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "vue-simple-spinner";

import VSwitch from "../../../components/Common/VSwitch.vue";

import TimingOptions from "../../../Mixins/timingOptions";

export default {
  name: "WelcomeNotification",
  mixins: [TimingOptions],
  data() {
    return {
      isLoading: false,
      currentCustomerPhoneNumber: null,
      showCustomerInfoModal: false,
      products: {},
      abandonedCartNotificationConfig: {}
    };
  },
  components: {
    VSwitch,
    Spinner
  },
  computed: {
    config() {
      return this.$store.getters.getConfig;
    }
  },
  created() {
    this.$store.dispatch("getConfig");
    this.getAutomationConfig();
    this.updateOnboadingFlag();
  },
  mounted() {},
  methods: {
    async getAutomationConfig() {
      this.isLoading = true;
      this.$store.dispatch("getAutomationConfig").then(response => {
        this.abandonedCartNotificationConfig =
          response.config.abandonedCartNotification;
        this.isLoading = false;
      });
    },
    gotoConfigEditor(index) {
      this.$router.push({
        name: "AbandonedCartConfig",
        params: { index }
      });
    },
    updateNotificationConfig() {
      this.$store
        .dispatch("updateAutomationConfig", {
          requestParams: {
            notificationConfig: {
              ...this.notificationConfig,
              abandonedCartNotification: this.abandonedCartNotificationConfig
            }
          }
        })
        .then(() => {
          this.$store.dispatch("showNotification", {
            text: "Settings Updated"
          });
        });
    },
    updateOnboadingFlag() {
      this.$store.dispatch("updateOnboardingFlag", {
        requestParams: {
          flag: "isAutomatedAbandonedVisited"
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
